import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
export type DragEventType = 'dragover' | 'dragleave';

@Directive({
    selector: '[aumico-drop-file]',
})
export class AumicoDropFileDirective {
    @Input()
    public accept = '.xls,.xlsx,.XLSX,.XLS';
    @Output() fileDroppedEvent: EventEmitter<File> = new EventEmitter();

    @Output() stateEvent: EventEmitter<DragEventType> = new EventEmitter();

    // @HostBinding('style.background') private background = '#eee';

    constructor(private sanitizer: DomSanitizer) {}

    @HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.stateEvent.emit('dragover');
    }

    @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.stateEvent.emit('dragleave');
    }

    @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.stateEvent.emit('dragleave');

        let file: File = null;
        for (let i = 0; i < evt.dataTransfer.files.length; i++) {
            file = evt.dataTransfer.files[i];
            // const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
            // file.push({ file, url });
            if (this.accept.split(',').some((extension) => file.name.endsWith(extension))) {
                this.fileDroppedEvent.emit(file);
                break;
            }
        }
    }
}
